// @ts-nocheck
import { t } from 'ttag'

export const getDefaultLabels = () => [t`Low`, t`High`]

export const getDefaultTooltips = value => {
  const labels = [
    t`very low priority`,
    t`low priority`,
    t`medium priority`,
    t`high priority`,
    t`very high priority`,
  ]

  const index = Math.floor(value * 0.999 * labels.length)

  return labels[index]
}
